import React, { useEffect, ReactNode } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TypeInitialState } from "../../store/slice/authSliceLogin/authSliceLogin";

const NotAuthorizeRoute = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element | null => {
  const isAuthenticated = useSelector(
    (state: { authSlice: TypeInitialState }) => state.authSlice
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (isAuthenticated?.success) {
      return navigate("/");
    }
  }, [isAuthenticated?.LoadingPage, isAuthenticated?.success, navigate]);
  if (!isAuthenticated?.success) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return null;
};

export default NotAuthorizeRoute;
